import React from "react";
import { Button } from "react-bootstrap";

const Search = ({ setBody, searchHandler }) => {
  return (
    <div className="position-relative iconWithText">
      <input
        type="search"
        placeholder="Search"
        style={{ width: 220 }}
        className="form-control rounded-pill ps-3"
        onChange={(e) =>
          setBody((p) => ({
            ...p,
            search: e.target.value,
          }))
        }
      />
      <Button
        className="border-0 p-0 icn position-absolute"
        variant="transparent"
        style={{ left: 175 }}
        type="button"
        onClick={searchHandler}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clip-path="url(#clip0_1_212)">
            <path
              d="M9.07232 2.80539C10.2757 2.80429 11.4524 3.16014 12.4536 3.82792C13.4547 4.49569 14.2353 5.4454 14.6965 6.55688C15.1578 7.66837 15.2791 8.8917 15.045 10.0721C14.8109 11.2525 14.232 12.337 13.3814 13.1883C12.5309 14.0396 11.4469 14.6196 10.2667 14.8548C9.08652 15.0899 7.86308 14.9698 6.75117 14.5095C5.63927 14.0493 4.68885 13.2695 4.02016 12.269C3.35147 11.2685 2.99455 10.0921 2.99455 8.88873C3.00184 7.27853 3.64434 5.73629 4.78241 4.59718C5.92048 3.45807 7.46214 2.81416 9.07232 2.80539ZM9.07232 1.6665C7.6439 1.6665 6.24756 2.09008 5.05987 2.88367C3.87218 3.67726 2.94649 4.80521 2.39986 6.1249C1.85323 7.44459 1.7102 8.89674 1.98887 10.2977C2.26754 11.6987 2.95539 12.9856 3.96544 13.9956C4.97549 15.0057 6.26236 15.6935 7.66334 15.9722C9.06431 16.2508 10.5165 16.1078 11.8361 15.5612C13.1558 15.0146 14.2838 14.0889 15.0774 12.9012C15.871 11.7135 16.2945 10.3171 16.2945 8.88873C16.2945 6.97327 15.5336 5.13627 14.1792 3.78184C12.8248 2.42741 10.9878 1.6665 9.07232 1.6665Z"
              fill="#494949"
            />
            <path
              d="M19.4444 18.4943L15.3499 14.3721L14.561 15.1554L18.6555 19.2776C18.7069 19.3294 18.768 19.3706 18.8354 19.3988C18.9027 19.4269 18.975 19.4416 19.048 19.4418C19.121 19.4421 19.1933 19.428 19.2608 19.4003C19.3284 19.3726 19.3898 19.3318 19.4416 19.2804C19.4934 19.229 19.5346 19.1678 19.5627 19.1005C19.5909 19.0332 19.6055 18.9609 19.6058 18.8879C19.606 18.8149 19.5919 18.7426 19.5642 18.6751C19.5365 18.6075 19.4958 18.5461 19.4444 18.4943Z"
              fill="#494949"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_212">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </Button>
    </div>
  );
};

export default Search;
